import Board from './component/board';
import './component/style.css';

function App() {
  return (
    <div className="App" id='main'>
        <Board></Board>
    </div>
  );
}

export default App;